module.exports = __webpack_public_path__ + "30790de0a4d08550822876fd75c8e9ae.ttf";